module.exports = __webpack_public_path__ + "img/iconfaoffer.a255851b.png";